import { LocationType, StagingType } from "./Enums";
import { StagingItem } from "./StagingItem";

export class ScheduleParameters {
    locCode: string = '';
    locationType: LocationType = LocationType.Origin;
    stagingType: StagingType = StagingType.Contracts;
    planPeriod: string = '';
    periodStartDate: string = '';
    periodEndDate: string = '';
    shipThroughDate: string = '';
    loadDefaultFilters: boolean = false;
    commodityCode: string = '';
    locationId: number = 0;
    locationName: string = '';
    locationCity: string = '';
    customerId: number = 0;
    truckerId: number = 0;
    truckerCode: number = 0;
    stagingItems: StagingItem[] = [];
    selectedPeriodRange: string = '';
    originId: number = 0;
    destinationId: number = 0;
    searchFor: string = 'Schedules';
    trucker: string = '';
    loadDate: string = '';
    deliveryDate: string = '';
    loadNumber: string = '';
    whetherFilterIfTruckerIdIsNotAvailable: boolean = false;
    commodityCodeList: string[] = [];
    originIdList: number[] = [];
    destinationIdList: number[] = [];
}
